var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 12" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M8.5 12C4.1 12 .7 6.8.5 6.6c-.2-.3-.2-.8 0-1.1.2-.3 3.6-5.5 8-5.5s7.8 5.2 8 5.4c.2.3.2.8 0 1.1-.2.3-3.6 5.5-8 5.5zM2.6 6c.9 1.2 3.3 4 5.9 4 2.4 0 4.8-2.5 5.9-3.9-.9-1.2-3.3-4-5.9-4S3.5 4.8 2.6 6z" }),
    React.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "8.4", cy: "5.8", r: "2.8" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Inspected.svg